export function findFilter(filterConfig, field) {
  return Object.values(filterConfig).find(f => !!f && f.field === field);
}
export function getFilterOptions(filter) {
  if (filter.options.length > 0) return filter.options;
  return filter.optionGroups.flatMap(g => g.options);
}
export function isValidFilterValue(filter, value) {
  const options = getFilterOptions(filter);
  if (options.length > 0) return options.some(o => o.value === value);
  if (filter.dataType === 'BOOLEAN') return value === 'true' || value === 'false';
  return true;
}